import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/', // 首頁
    name: 'Home',
    component: () => import( '../views/Home.vue')
  },
  {
    path: '/Register', // 註冊頁面
    name: 'Register',
    component: () => import( '../views/User/Register.vue')
  },
  {
    path: '/ForgetPassword', // 註冊頁面
    name: 'ForgetPassword',
    component: () => import( '../views/User/ForgetPassword.vue')
  },
  {
    path: '/Login', // 登入頁面
    name: 'Login',
    component: () => import( '../views/User/Login.vue')
  },
  {
    path: '/User', // 會員資料頁面
    name: 'User',
    component: () => import( '../views/User/User.vue')
  },
  {
    path: '/Attentions', // 消費者最近十筆訂單頁面
    name: 'Attentions',
    component: () => import( '../views/User/Attentions.vue')
  },
  {
    path: '/Orders', // 消費者最近十筆訂單頁面
    name: 'Orders',
    component: () => import( '../views/User/Orders.vue')
  },
  {
    path: '/Order/:id', // 消費者最近十筆訂單頁面
    name: 'Order',
    component: () => import( '../views/User/Order.vue')
  },
  {
    path: '/Groupbuies', // 消費者最近十筆訂單頁面
    name: 'Groupbuies',
    component: () => import( '../views/User/Groupbuies.vue')
  },
  {
    path: '/Advertises', // 好康頁面
    name: 'Advertises',
    component: () => import( '../views/User/Advertises.vue')
  },
  {
    path: '/Shop/:id/:Token?', // 店家頁面
    name: 'Shop',
    component: () => import( '../views/Shop/Shop.vue'),
    props: true
  },
  {
    path: '/Cart', // 結帳頁面
    name: 'Cart',
    component: () => import('@/views/Pay/Cart.vue')
  },
  {
    path: '/LINEPayRequest', // LINEPay 請求頁面
    name: 'LINEPayRequest',
    component: () => import('@/views/Pay/LINEPayRequest.vue')
  },
  {
    path: '/LINEPayConfirm', // LINEPay 確認頁面
    name: 'LINEPayConfirm',
    component: () => import('@/views/Pay/LINEPayConfirm.vue')
  },
  {
    path: '/LINENotifyCallback',
    name: 'LINENotifyCallback',
    component: () => import('@/views/LINE/LINENotifyCallback.vue')
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory('/OrderUser/'),
  routes
})

export default router
